// extracted by mini-css-extract-plugin
export default {"nodataContainer":"NoResult_nodataContainer__zzl5N","nodataContent":"NoResult_nodataContent__Ci9Fp","label":"NoResult_label__ly-Ei"};